import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Settings from '@material-ui/icons/SettingsApplications'
import RoleHelper from 'helpers/role'
import messages from '../translate'

function Headline(props) {
  const {
    intl: { formatMessage },
    activeSite,
    activeLocus,
    roleLevel,
    switcher,
  } = props

  return (
    <div className="ma-headline">
      <div className="ma-breadcrumbs">
        <span className="level-licensee">
          {formatMessage(messages.allSites)}
        </span>
        {Boolean(activeSite.get('name').length) && (
          <span className="level-site">{activeSite.get('name')}</span>
        )}
        {Boolean(activeLocus.get('containerName').length) && (
          <span className="level-locus">
            {activeLocus.get('containerName')}
          </span>
        )}
      </div>
      {roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL && (
        <Settings className="settings-icon" onClick={switcher} />
      )}
    </div>
  )
}

export default connect(state => ({
  roleLevel: state.getIn(['profile', 'roleLevel']),
  activeSite: state.getIn(['monitorsAndAlerts', 'activeSite']),
  activeLocus: state.getIn(['monitorsAndAlerts', 'activeLocus']),
}))(injectIntl(Headline))
